import React, { useContext } from "react";
import Selector from "./selectors";
import { onPageBuilderOptionValueClickHandler } from "../../../utils/ProductBuilderHelper";
import { ProductBuilderSelection } from "../../../types/ProductBuilderTypes";
import TrackingUtil from "../../../utils/tracking";
import { BffDataContext } from "../../../contexts/BffDataContextProvider";
import { ProductContext } from "../../../contexts/ProductContextProvider";
import { ProductOptionsTranslations } from "@vp/product-options-ui";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";

interface BuilderOptionProps {
  selection: ProductBuilderSelection;
  index: number;
  disabled: boolean;
  removePadding: boolean;
}

const BuilderOption = (props: BuilderOptionProps) => {
  const { index, selection, disabled, removePadding } = props;
  const { compatibleValues, attributeConstraints } = useContext(BffDataContext);
  const { locale } = useContext(PageStaticDataContext);
  const { selections = {}, selectCompatibleValue, selectIncompatibleValue } = useContext(
    ProductContext
  );

  return (
    <ProductOptionsTranslations locale={locale}>
      <Selector
        builderSelection={selection}
        removePadding={removePadding}
        selectorIndex={index}
        key={`on-page-selector-${index}`}
        disabled={disabled}
        onChange={(newValue: string | null) => {
          TrackingUtil.trackBuilderSelection({
            optionKey: selection.property.key,
            valueKey: newValue || "",
          });
          onPageBuilderOptionValueClickHandler({
            option: selection.property,
            selectedValue: newValue,
            attributeConstraints: attributeConstraints,
            selections: selections,
            compatibleValues: compatibleValues,
            isRanged: selection.selectionStyle === "Text box",
            userSelectValue: selectCompatibleValue,
            userSelectIncompatibleValue: selectIncompatibleValue,
          });
        }}
      />
    </ProductOptionsTranslations>
  );
};

export default BuilderOption;
